// Aggregate numbers for a list of bets (BetsPage, Mundial2026Page, Home).
// Void bets are excluded from the staked total; pending stakes are added
// back to profit so open bets don't count as losses yet.
export function computeBetStats(bets) {
  const wonBets = bets.filter(b => b.result === 'won');
  const lostBets = bets.filter(b => b.result === 'lost');
  const pendingBets = bets.filter(b => b.result === 'pending');
  const voidBets = bets.filter(b => b.result === 'void');
  const nonVoidBets = bets.filter(b => b.result !== 'void');

  const totalStake = nonVoidBets.reduce((sum, b) => sum + (b.amount || 0), 0);
  const totalWinnings = wonBets.reduce((sum, b) => sum + (b.amount || 0) * b.totalOdd, 0);
  const pendingAmount = pendingBets.reduce((sum, b) => sum + (b.amount || 0), 0);
  const profit = totalWinnings - totalStake + pendingAmount;
  const completed = wonBets.length + lostBets.length;
  const winRate = completed > 0 ? (wonBets.length / completed) * 100 : 0;
  const settledStake = totalStake - pendingAmount;
  const roi = settledStake > 0 ? (profit / settledStake) * 100 : 0;

  return {
    totalBets: bets.length,
    wonBets: wonBets.length,
    lostBets: lostBets.length,
    pendingBets: pendingBets.length,
    voidBets: voidBets.length,
    totalStake,
    totalWinnings,
    profit,
    winRate,
    roi,
  };
}

// Running profit after each settled bet, oldest first. Expects bets sorted
// newest-first (as useBetsData returns them). Ends at the same value as
// computeBetStats().profit.
export function computeProfitSeries(bets) {
  const series = [];
  let running = 0;
  for (let i = bets.length - 1; i >= 0; i -= 1) {
    const b = bets[i];
    const amount = b.amount || 0;
    if (b.result === 'won') running += amount * b.totalOdd - amount;
    else if (b.result === 'lost') running -= amount;
    else continue;
    series.push({ date: b.date, value: running });
  }
  return series;
}

export function formatMoney(value, { sign = false } = {}) {
  const n = Number(value) || 0;
  const prefix = sign && n > 0 ? '+' : '';
  return `${prefix}${n.toFixed(2)}€`;
}
